import React, { createContext, useContext, useState } from 'react';

interface TabContextType {
  tab: number;
  setTab: (tab: number) => void;
  activeAlertsCount: number;
  setActiveAlertsCount: (count: number) => void;
}

const TabContext = createContext<TabContextType | undefined>(undefined);

export function TabProvider({ children }: { children: React.ReactNode }) {
  const [tab, setTab] = useState(0);
  const [activeAlertsCount, setActiveAlertsCount] = useState(0);

  return (
    <TabContext.Provider value={{ tab, setTab, activeAlertsCount, setActiveAlertsCount }}>
      {children}
    </TabContext.Provider>
  );
}

export function useTabContext() {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTabContext must be used within TabProvider');
  }
  return context;
}
